// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://metroplanorlando-vendor.aclarian.com',
  appName: 'MetroPlan Orlando  | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pube1441f8c33afa2f53eaced011e85ce97',
  datadogApplicationId: 'ae3510bb-9d83-4c68-ad65-4ddaa9e3bdcf',
  datadogService: 'invoicing_metroplan_prod',
  ApiKey: 'Xp5@VLD%zT62Ry#Q',
  env: 'PROD',
  version: packageInfo.version,
};
